<template>
    <div v-if="isCurrentStep">
        <NextStep title="Apply to Jobs That Match Your Target Role">
            <p>Now that you have a targeted resume scoring 75+, it's time to put it to work.</p>
            <br />
            <p class="font-bold">Your next steps:</p>
            <ol class="list-decimal pl-4">
                <li>Apply to at least <span class="font-bold">50 jobs</span> that match your target job title</li>
                <li>Use your primary resume for each application</li>
                <li>Track your interview rate with JobTrackerAI</li>
            </ol>
            <br />
            <p>
                Your interview rate (shown below) is the percentage of applications that result in interview
                invitations.
            </p>
            <br />
            <p>A rate of 2% or higher indicates your approach is working.</p>
        </NextStep>
    </div>
    <div v-else-if="isStepPassed">
        <NextStep title="Review">
            <p>You've applied to 50+ positions aligned with your target role.</p>
            <br />
            <p>
                Your interview rate of 2%+ confirms your resume and job targeting strategy are working effectively in
                the real world.
            </p>
        </NextStep>
    </div>
    <div v-else>
        <NextStep title="Preview">
            <p>Apply to at least 50 jobs matching your target role using your optimized resume.</p>
            <br />
            <p>Your interview rate (tracked by JobTrackerAI) will tell you if your approach is working.</p>
            <br />
            <p>Aim for a 2%+ interview rate.</p>
        </NextStep>
    </div>

    <button
        class="bg-won-green w-full text-white py-1.5 px-3 rounded text-sm"
        type="button"
        @click="() => emit('open-feature')"
    >
        Start Applying to Jobs →
    </button>

    <SidebarCard space-y="space-y-0">
        <span class="text-won-blue-light text-4xl font-semibold text-center">{{ jobsApplied }}</span>
        <span class="text-won-blue text-sm font-semibold text-center">Jobs Applied</span>
    </SidebarCard>

    <PlanTabGroup :tabs="tabs" />
</template>

<script setup>
import { storeToRefs } from "pinia";

import { useJobSearchPlanStore } from "../../../store/job-search-plan.store";

import NextStep from "../next-step.vue";
import SidebarCard from "../sidebar-card.vue";
import PlanTabGroup from "../plan-tab-group.vue";

import { UserGroupIcon, UserIcon } from "@heroicons/vue/20/solid";

const emit = defineEmits(["open-feature"]);
const props = defineProps({
    isStepPassed: {
        type: Boolean,
        default: false,
        required: true,
    },
    isCurrentStep: {
        type: Boolean,
        default: false,
        required: true,
    },
});

const jobSearchPlanStore = useJobSearchPlanStore();
const { jobsApplied, interviewRate, timeToInterview } = storeToRefs(jobSearchPlanStore);

const tabs = [
    {
        title: "your average",
        icon: UserIcon,
        values: [
            { type: "percents", value: interviewRate.value, label: "Interview Rate" },
            {
                type: "days",
                value: timeToInterview.value,
                label: "Time to Interview",
            },
        ],
        isComingSoon: false,
    },
    {
        title: "other users",
        icon: UserGroupIcon,
        isComingSoon: true,
    },
];
</script>
